<template>
    <div class="hotel-page">
        <page-breadcrumb :items="pageBreadcrumbItems" :mobile="ebkMobile" />
        <!-- 筛选：桌面 -->
        <div
            v-show="!ebkMobile"
            class="row ai-c wrap filter-toolbar"
            data-ebk-guide="hotel-filter"
        >
            <span class="fc-sub mt-1 mr-1">国家:</span>
            <el-select
                v-model="country_id"
                clearable
                class="mt-1 hundred"
                size="small"
                placeholder="请选择"
                filterable
            >
                <el-option
                    v-for="item in countryData"
                    :key="item.country_id"
                    :label="item.country_name_chn"
                    :value="item.country_id"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3 mt-1 mr-1">城市:</span>
            <el-select
                size="small"
                class="mt-1 hundred-eight"
                v-model="city_id"
                clearable
                filterable
                remote
                :remote-method="remoteMethod"
                reserve-keyword
                placeholder="请选择或输入关键词"
            >
                <el-option
                    v-for="item in cityData"
                    :key="item.city_id"
                    :label="item.city_name_chn"
                    :value="item.city_id"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3 mt-1 mr-1">品牌:</span>
            <el-select
                v-model="brand_id"
                clearable
                class="mt-1 hundred"
                size="small"
                filterable
                remote
                :remote-method="remoteBrand"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in brandData"
                    :key="item.brand_id"
                    :label="item.rb_name"
                    :value="item.brand_id"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3 mt-1 mr-1">等级:</span>
            <el-select
                v-model="grade_id"
                clearable
                class="mt-1 hundred"
                size="small"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in gradeData"
                    :key="item.grade_id"
                    :label="item.rg_name"
                    :value="item.grade_id"
                >
                </el-option>
            </el-select>
            <span class="fc-sub ml-3 mt-1 mr-1">销售类型:</span>
            <el-select
                v-model="res_up_status"
                clearable
                class="mt-1 hundred"
                size="small"
                placeholder="请选择"
            >
                <el-option label="全部" value="-1"></el-option>
                <el-option label="禁售" value="2"></el-option>
                <el-option label="手动禁售" value="3"></el-option>
            </el-select>
            <span class="fc-sub ml-3 mt-1 mr-1">名称:</span>
            <el-input
                placeholder="请输入酒店名称"
                v-model="res_name"
                size="small"
                clearable
                class="mt-1 hundred"
                style="width: 150px"
            ></el-input>
            <el-button
                type="primary"
                icon="el-icon-search"
                class="ml-3 pl-3 mt-1"
                data-ebk-guide="hotel-search"
                @click="changeStatus"
                size="small"
                >查询</el-button
            >
            <el-button
                type="primary"
                icon="el-icon-plus"
                class="ml-3 pl-3 mt-1"
                data-ebk-guide="hotel-add"
                @click="openAddHotelDialog"
                :disabled="!canMaintainHotel"
                :title="canMaintainHotel ? '' : '仅直签自营供应商可新增酒店'"
                size="small"
                >新增酒店</el-button
            >
        </div>

        <!-- 筛选：移动端 -->
        <div v-show="ebkMobile" class="hotel-mobile-filters" data-ebk-guide="hotel-filter">
            <el-collapse v-model="mobileFilterActive" accordion>
                <el-collapse-item title="筛选条件" name="filter">
                    <div class="hotel-m-fields">
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">国家</span>
                            <el-select
                                v-model="country_id"
                                clearable
                                class="hotel-m-control"
                                size="small"
                                placeholder="请选择"
                                filterable
                            >
                                <el-option
                                    v-for="item in countryData"
                                    :key="item.country_id"
                                    :label="item.country_name_chn"
                                    :value="item.country_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">城市</span>
                            <el-select
                                size="small"
                                class="hotel-m-control"
                                v-model="city_id"
                                clearable
                                filterable
                                remote
                                :remote-method="remoteMethod"
                                reserve-keyword
                                placeholder="请选择或输入关键词"
                            >
                                <el-option
                                    v-for="item in cityData"
                                    :key="item.city_id"
                                    :label="item.city_name_chn"
                                    :value="item.city_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">品牌</span>
                            <el-select
                                v-model="brand_id"
                                clearable
                                class="hotel-m-control"
                                size="small"
                                filterable
                                remote
                                :remote-method="remoteBrand"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in brandData"
                                    :key="item.brand_id"
                                    :label="item.rb_name"
                                    :value="item.brand_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">等级</span>
                            <el-select
                                v-model="grade_id"
                                clearable
                                class="hotel-m-control"
                                size="small"
                                placeholder="请选择"
                            >
                                <el-option
                                    v-for="item in gradeData"
                                    :key="item.grade_id"
                                    :label="item.rg_name"
                                    :value="item.grade_id"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">销售类型</span>
                            <el-select
                                v-model="res_up_status"
                                clearable
                                class="hotel-m-control"
                                size="small"
                                placeholder="请选择"
                            >
                                <el-option label="全部" value="-1"></el-option>
                                <el-option label="禁售" value="2"></el-option>
                                <el-option label="手动禁售" value="3"></el-option>
                            </el-select>
                        </div>
                        <div class="hotel-m-field">
                            <span class="hotel-m-label">名称</span>
                            <el-input
                                placeholder="请输入酒店名称"
                                v-model="res_name"
                                size="small"
                                clearable
                                class="hotel-m-control"
                            ></el-input>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="hotel-m-actions">
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    data-ebk-guide="hotel-search"
                    @click="changeStatus"
                    >查询</el-button
                >
                <el-button
                    type="primary"
                    size="small"
                    plain
                    icon="el-icon-plus"
                    data-ebk-guide="hotel-add"
                    @click="openAddHotelDialog"
                    :disabled="!canMaintainHotel"
                    :title="canMaintainHotel ? '' : '仅直签自营供应商可新增酒店'"
                    >新增酒店</el-button
                >
            </div>
        </div>

        <div v-show="!ebkMobile" class="table-scroll-x">
        <el-table
            :data="tableData"
            stripe
            size="small"
            style="width: 100%"
            class="mt-3 pt-3"
            highlight-current-row
            border
        >
            <el-table-column
                type="index"
                width="50">
            </el-table-column>
            <el-table-column
                prop="res_name"
                label="酒店名称"
                width="280px"
            ></el-table-column>
            <el-table-column
                prop="city_name_chn"
                label="城市"
            ></el-table-column>
            <el-table-column prop="" label="匹配状态">
                <template slot-scope="scope">
                    <span :class="scope.row.status=='已配'?'fc-s':(scope.row.status=='未配'?'fc-e':'fc-g')">{{scope.row.status}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop=""
                label="上架状态"
            >
                <template slot-scope="scope">
                    <span :class="scope.row.res_up==1?'fc-s':(scope.row.res_up==0?'fc-e':'fc-g')">{{scope.row.res_up_name}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="grade" label="酒店等级"></el-table-column>
            <el-table-column
                prop="res_phone"
                label="酒店电话"
                width="150px"
            ></el-table-column>
            <el-table-column
                prop="res_adress"
                label="酒店地址"
                width="300px"
            ></el-table-column>
            <el-table-column
                prop=""
                label="备注"
                width="200px"
            >
                <template slot-scope="scope">
                    <div style="width:200px;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;" :title="scope.row.rb_deposit_and_prepaid">{{scope.row.rb_deposit_and_prepaid}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="operate" label="操作" width="200px">
                <template slot-scope="scope">
                    <el-button
                        @click="lookRoomType(scope.row)"
                        type="text"
                        size="small"
                        data-ebk-guide="hotel-room-btn"
                        >查看房型</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        </div>

        <!-- 移动端：卡片列表 -->
        <div v-show="ebkMobile" class="hotel-card-list">
            <div
                v-for="(row, idx) in tableData"
                :key="hotelCardRowKey(row, idx)"
                class="hotel-card"
                @click="lookRoomType(row)"
            >
                <div class="hotel-card__head row jc-sb ai-c">
                    <div class="hotel-card__title">{{ row.res_name || "—" }}</div>
                    <span
                        class="hotel-card__badge"
                        :class="
                            'hotel-card__badge--' + hotelMatchStatusTone(row)
                        "
                        >{{ row.status || "—" }}</span
                    >
                </div>
                <div class="hotel-card__row hotel-card__row--split">
                    <span class="hotel-card__inline">
                        <span class="hotel-card__k">城市</span>
                        {{ row.city_name_chn || "—" }}
                    </span>
                    <span class="hotel-card__inline hotel-card__inline--r">
                        <span
                            :class="
                                row.res_up == 1
                                    ? 'fc-s'
                                    : row.res_up == 0
                                      ? 'fc-e'
                                      : 'fc-g'
                            "
                            >{{ row.res_up_name || "—" }}</span
                        >
                    </span>
                </div>
                <div class="hotel-card__row hotel-card__row--split">
                    <span class="hotel-card__inline">
                        <span class="hotel-card__k">等级</span>
                        {{ row.grade || "—" }}
                    </span>
                    <span class="hotel-card__inline hotel-card__inline--r">
                        <span class="hotel-card__k">电话</span>
                        {{ row.res_phone || "—" }}
                    </span>
                </div>
                <div class="hotel-card__row">
                    <span class="hotel-card__k">地址</span>
                    <span class="hotel-card__v hotel-card__addr">{{
                        row.res_adress || "—"
                    }}</span>
                </div>
                <div
                    v-if="row.rb_deposit_and_prepaid"
                    class="hotel-card__remark"
                >
                    {{ row.rb_deposit_and_prepaid }}
                </div>
                <div class="hotel-card__foot">
                    <span
                        class="hotel-card__foot-link"
                        :data-ebk-guide="idx === 0 ? 'hotel-room-btn' : null"
                        >查看房型</span
                    >
                </div>
            </div>
            <div v-if="!tableData.length" class="hotel-card-empty">
                暂无酒店数据
            </div>
        </div>

        <div class="mt-3 pt-3 hotel-pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 15, 20]"
                :page-size="limit"
                :layout="
                    ebkMobile
                        ? 'total, prev, pager, next'
                        : 'total, sizes, prev, pager, next, jumper'
                "
                :small="ebkMobile"
                :pager-count="ebkMobile ? 5 : 7"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 新增选择母酒店弹框 -->
        <el-dialog
            title="新增酒店"
            :custom-class="
                'add-hotel-dialog' +
                (ebkMobile ? ' add-hotel-dialog--mobile' : '')
            "
            :visible.sync="centerDialogVisible"
            :width="ebkMobile ? '92%' : '920px'"
            :top="ebkMobile ? '3vh' : '5vh'"
            :close-on-click-modal="false"
            :append-to-body="true"
        >
            <div class="add-hotel-body">
                <div class="add-hotel-tip">
                    <i class="el-icon-info add-hotel-tip__icon"></i>
                    <p class="add-hotel-tip__text">
                        先选<strong>国家、城市</strong>并填写<strong>酒店名称</strong>后点击查询；<strong>AI 检索须填地址</strong>，电话选填可辅助匹配。
                    </p>
                </div>
                <div class="add-hotel-toolbar">
                    <div class="add-hotel-grid">
                        <span class="gh-lbl"
                            >国家<span class="add-hotel-req">*</span></span
                        >
                        <el-select
                            v-model="country_id"
                            clearable
                            placeholder="请选择"
                            size="small"
                            filterable
                            class="gh-field"
                        >
                            <el-option
                                v-for="item in countryData"
                                :key="item.country_id"
                                :label="item.country_name_chn"
                                :value="item.country_id"
                            >
                            </el-option>
                        </el-select>
                        <span class="gh-lbl"
                            >城市<span class="add-hotel-req">*</span></span
                        >
                        <el-select
                            v-model="city_id"
                            clearable
                            placeholder="请选择或搜索"
                            size="small"
                            filterable
                            remote
                            :remote-method="remoteMethod"
                            reserve-keyword
                            class="gh-field"
                        >
                            <el-option
                                v-for="item in cityData"
                                :key="item.city_id"
                                :label="item.city_name_chn"
                                :value="item.city_id"
                            >
                            </el-option>
                        </el-select>

                        <span class="gh-lbl"
                            >名称<span class="add-hotel-req">*</span></span
                        >
                        <el-input
                            placeholder="与母库一致（必填）"
                            v-model="res_name"
                            size="small"
                            clearable
                            class="gh-field gh-span-rest"
                        ></el-input>

                        <span class="gh-lbl"
                            >地址<span
                                v-if="motherSearchIsAi"
                                class="add-hotel-req"
                                >*</span
                            ></span
                        >
                        <el-input
                            :placeholder="
                                motherSearchIsAi
                                    ? 'AI 检索必填，建议与门店地址一致'
                                    : '选填，辅助匹配'
                            "
                            v-model="mother_res_adress"
                            size="small"
                            clearable
                            class="gh-field gh-span-rest"
                        ></el-input>

                        <span class="gh-lbl">电话</span>
                        <el-input
                            placeholder="选填"
                            v-model="mother_res_phone"
                            size="small"
                            clearable
                            class="gh-field"
                        ></el-input>
                        <span class="gh-lbl">检索</span>
                        <el-select
                            v-model="mother_search_type"
                            placeholder="检索方式"
                            size="small"
                            class="gh-field"
                            :clearable="false"
                        >
                            <el-option label="AI" value="ai"></el-option>
                            <el-option label="艺龙" value="ylApi"></el-option>
                        </el-select>
                    </div>
                </div>
                <div
                    class="add-hotel-list-head"
                    :class="{ 'add-hotel-list-head--m': ebkMobile }"
                >
                    <div class="add-hotel-table-caption fc-sub">
                        母酒店列表（行内点「新增」完成绑定）
                    </div>
                    <div class="add-hotel-query-bar">
                        <el-button
                            type="primary"
                            icon="el-icon-search"
                            size="small"
                            class="add-hotel-query-btn"
                            @click="searchHotelList"
                            >查询母酒店</el-button
                        >
                    </div>
                </div>
                <div
                    v-show="!ebkMobile"
                    class="add-hotel-table-wrap table-scroll-x"
                >
                    <el-table
                        :data="mTableData"
                        stripe
                        border
                        size="small"
                        class="add-hotel-table"
                        :max-height="addHotelTableMaxHeight"
                    >
                        <el-table-column
                            prop="res_name"
                            label="酒店名称"
                            min-width="130"
                            show-overflow-tooltip
                        ></el-table-column>
                        <el-table-column
                            prop="res_phone"
                            label="电话"
                            min-width="108"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="res_adress"
                            label="地址"
                            min-width="120"
                            show-overflow-tooltip
                        >
                        </el-table-column>
                        <el-table-column
                            prop="calibrated_distance"
                            label="校准距离"
                            width="80"
                            align="right"
                        ></el-table-column>
                        <el-table-column
                            label="操作"
                            width="72"
                            align="center"
                        >
                            <template slot-scope="scope">
                                <el-popconfirm
                                    title="确定新增该酒店数据吗？"
                                    @confirm="addHotel(scope.row)"
                                >
                                    <el-button
                                        type="text"
                                        slot="reference"
                                        size="small"
                                        >新增</el-button
                                    >
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <!-- 移动端：母酒店卡片列表（避免表格横向滚动） -->
                <div v-show="ebkMobile" class="add-hotel-m-cards">
                    <div
                        v-for="(row, idx) in mTableData"
                        :key="motherHotelCardKey(row, idx)"
                        class="add-hotel-m-card"
                    >
                        <div class="add-hotel-m-card__title">
                            {{ row.res_name || "—" }}
                        </div>
                        <div class="add-hotel-m-card__row">
                            <span class="add-hotel-m-card__k">电话</span>
                            <span class="add-hotel-m-card__v">{{
                                row.res_phone || "—"
                            }}</span>
                        </div>
                        <div class="add-hotel-m-card__block">
                            <span class="add-hotel-m-card__k">地址</span>
                            <span class="add-hotel-m-card__v">{{
                                row.res_adress || "—"
                            }}</span>
                        </div>
                        <div
                            v-if="
                                row.calibrated_distance !== undefined &&
                                row.calibrated_distance !== null &&
                                row.calibrated_distance !== ''
                            "
                            class="add-hotel-m-card__row"
                        >
                            <span class="add-hotel-m-card__k">校准距离</span>
                            <span class="add-hotel-m-card__v">{{
                                row.calibrated_distance
                            }}</span>
                        </div>
                        <div class="add-hotel-m-card__foot">
                            <el-button
                                type="primary"
                                plain
                                size="small"
                                class="add-hotel-m-card__bind"
                                @click="openAddHotelConfirm(row)"
                                >新增绑定</el-button
                            >
                        </div>
                    </div>
                    <div
                        v-if="!mTableData.length"
                        class="add-hotel-m-card-empty"
                    >
                        暂无数据
                    </div>
                </div>
                <div
                    v-show="mTotal > 0"
                    class="add-hotel-pagination"
                >
                    <el-pagination
                        background
                        small
                        @size-change="mHandleSizeChange"
                        @current-change="mHandleCurrentChange"
                        :current-page="mpage"
                        :page-sizes="[5, 10, 15]"
                        :page-size="mlimit"
                        :layout="
                            ebkMobile
                                ? 'total, prev, pager, next'
                                : 'total, sizes, prev, pager, next, jumper'
                        "
                        :pager-count="ebkMobile ? 5 : 7"
                        :total="mTotal"
                    >
                    </el-pagination>
                </div>
            </div>
            <span
                slot="footer"
                class="dialog-footer add-hotel-footer"
                :class="{ 'add-hotel-footer--m': ebkMobile }"
            >
                <el-button size="small" @click="centerDialogVisible = false"
                    >关 闭</el-button
                >
            </span>
        </el-dialog>

        <!-- 移动端：确认绑定母酒店（替代 popconfirm，布局与触控更友好） -->
        <el-dialog
            title="提示"
            :visible.sync="addHotelConfirmVisible"
            append-to-body
            :width="ebkMobile ? '88%' : '420px'"
            :custom-class="
                'add-hotel-confirm-dialog' +
                (ebkMobile ? ' add-hotel-confirm-dialog--mobile' : '')
            "
            :close-on-click-modal="true"
            center
            @closed="addHotelConfirmRow = null"
        >
            <div class="add-hotel-confirm-body">
                <i
                    class="el-icon-warning add-hotel-confirm-ico"
                    aria-hidden="true"
                ></i>
                <div class="add-hotel-confirm-textwrap">
                    <p class="add-hotel-confirm-title">
                        确定新增该酒店数据吗？
                    </p>
                    <p
                        v-if="addHotelConfirmRow && addHotelConfirmRow.res_name"
                        class="add-hotel-confirm-sub"
                    >
                        {{ addHotelConfirmRow.res_name }}
                    </p>
                </div>
            </div>
            <span slot="footer" class="add-hotel-confirm-footer">
                <el-button
                    size="medium"
                    class="add-hotel-confirm-btn"
                    @click="addHotelConfirmVisible = false"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    size="medium"
                    class="add-hotel-confirm-btn"
                    @click="submitAddHotelConfirm"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
 
<script>
import qs from "qs";
import { Loading } from "element-ui";
import mobileBreakpoint from "@/mixins/mobileBreakpoint";
import supplierMaintain from "@/mixins/supplierMaintain";
import featureGuideMixin from "@/mixins/featureGuideMixin";
import { GUIDE_IDS } from "@/config/featureGuides";
import PageBreadcrumb from "@/components/PageBreadcrumb.vue";
var options = {
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
};
export default {
    name: "hotel",
    components: { PageBreadcrumb },
    mixins: [mobileBreakpoint, supplierMaintain, featureGuideMixin],
    data() {
        return {
            ebkFeatureGuideId: GUIDE_IDS.hotel,
            mobileFilterActive: "",
            bodyStyle: {
                padding: "10px",
            },
            countryData: [],
            cityData: [],
            brandData: [],
            gradeData: [],
            upData: [
                {
                    is_up: "-1",
                    label: "全部",
                },
                {
                    is_up: "1",
                    label: "上架",
                },
            ],
            noData: [
                {
                    no_t_id: "-1",
                    label: "全部",
                },
                {
                    no_t_id: "1",
                    label: "异常",
                },
            ],
            tableData: [],
            mTableData: [],
            options: [],
            country_id: "",
            city_id: "",
            brand_id: "",
            grade_id: "",
            res_name: "",
            is_up: "",
            no_t_id: "",
            res_up_status: "-1",
            page: 1,
            mpage: 1,
            limit: 10,
            mlimit: 5,
            total: 0,
            mTotal: 0,
            currentPage: 1,
            mCurrentPage: 1,
            centerDialogVisible: false,
            /** 移动端：确认绑定母酒店（替代 popconfirm） */
            addHotelConfirmVisible: false,
            addHotelConfirmRow: null,
            /** 新增酒店弹窗：母酒店检索辅助参数 */
            mother_res_adress: "",
            mother_res_phone: "",
            mother_search_type: "ai",
            userInfo: {},
            /** 母酒店表格最大高度，随窗口略变，避免小屏溢出 */
            addHotelTableMaxHeight: 440,
            ruleForm: {
                res_name: "",
                grade_id: "",
                res_up: "",
                rb_when_built: "",
                rb_renovation_date: "",
                res_phone: "",
                res_adress: "",
                rb_info: "",
            },
            rules: {
                res_name: [
                    {
                        required: true,
                        message: "请输入酒店名称",
                        trigger: "blur",
                    },
                ],
                grade_id: [
                    {
                        required: true,
                        message: "请选择酒店等级",
                        trigger: "blur",
                    },
                ],
                res_up: [
                    {
                        required: true,
                        message: "请选择上架状态",
                        trigger: "blur",
                    },
                ],
                rb_when_built: [
                    {
                        required: true,
                        message: "请选择建造时间",
                        trigger: "blur",
                    },
                ],
                rb_renovation_date: [
                    {
                        required: true,
                        message: "请选择装修时间",
                        trigger: "blur",
                    },
                ],
                res_phone: [
                    {
                        required: true,
                        message: "请输入酒店联系电话",
                        trigger: "blur",
                    },
                ],
                res_adress: [
                    {
                        required: true,
                        message: "请输入酒店地址",
                        trigger: "blur",
                    },
                ],
                rb_info: [
                    {
                        required: true,
                        message: "请输入酒店介绍",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    watch: {
        centerDialogVisible(val) {
            if (!val) {
                this.addHotelConfirmVisible = false;
                this.addHotelConfirmRow = null;
            }
        },
        country_id(val) {
            this.cityQueryData();
        },
    },
    computed: {
        pageBreadcrumbItems() {
            return [
                { label: "工作台", to: { path: "/hotel" } },
                { label: "酒店列表" },
            ];
        },
        motherSearchIsAi() {
            return this.mother_search_type === "ai";
        },
    },
    created() {
        this.userInfo = JSON.parse(this.getToken("userInfo"));
        this.countryQueryData();
        this.brandQueryData();
        this.gradeQueryData();
        this.hotelList();
    },
    mounted() {
        this.syncAddHotelTableMaxHeight();
        window.addEventListener("resize", this.syncAddHotelTableMaxHeight);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.syncAddHotelTableMaxHeight);
    },
    methods: {
        syncAddHotelTableMaxHeight() {
            const vh = window.innerHeight || 800;
            this.addHotelTableMaxHeight = Math.min(460, Math.max(220, Math.round(vh * 0.42)));
        },
        // 获取国家数据
        countryQueryData() {
            let data = {
                queryKey: "",
            };
            this.$axios
                .countryQueryData(qs.stringify(data))
                .then((res) => {
                    this.countryData = res;
                })
                .catch((err) => {
                    
                });
        },
        // 获取城市数据
        cityQueryData(e) {
             Loading.service(options);
            let data = {
                queryKey: e?e:"",
                editCountry: this.country_id,
            };
            this.$axios
                .cityQueryData(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    this.cityData = res;
                })
                .catch((err) => {
                    
                });
        },
        remoteBrand(e){
            setTimeout(()=>{
                this.brandQueryData(e);
            },500)
        },
        // 获取品牌数据
        brandQueryData(e) {
            let data = {
                queryKey: e?e:"",
            };
            this.$axios
                .brandQueryData(qs.stringify(data))
                .then((res) => {
                    this.brandData = res;
                })
        },
        // 获取等级数据
        gradeQueryData() {
            let data = {
                queryKey: "",
            };
            this.$axios
                .gradeQueryData(qs.stringify(data))
                .then((res) => {
                    this.gradeData = res;
                })
                .catch((err) => {
                    
                });
        },
        // 获取酒店列表数据
        hotelList() {
            Loading.service(options);
            let data = {
                dp_id: this.userInfo.dp_id,
                country_id: this.country_id,
                city_id: this.city_id,
                brand_id: this.brand_id,
                grade_id: this.grade_id,
                res_name: this.res_name,
                res_up_status: this.res_up_status,
                cnt: "",
                page: this.page,
                start: (this.page - 1) * this.limit,
                limit: this.limit,
            };
            this.$axios
                .hotelList(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res.goodsList) {
                        res.goodsList.map((val) => {
                            if (val.res_up == 1) {
                                val.res_up_name = "上架";
                            } else if (val.res_up == 0) {
                                val.res_up_name = "下架";
                            } else if (val.res_up == 3) {
                                val.res_up_name = "手动下架";
                            }
                        });
                        this.tableData = res.goodsList;
                        this.total = parseInt(res.totalCount);
                    } else {
                        if (res.length == 0) {
                            this.tableData = [];
                            this.total = 0;
                        }
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        searchHotelList() {
            if (!this.country_id || !this.city_id) {
                this.$message.warning("请先选择国家和城市后再查询");
                return;
            }
            if (!this.res_name || !String(this.res_name).trim()) {
                this.$message.warning("请输入酒店名称后再查询");
                return;
            }
            this.mpage = 1;
            this.showHotelList();
        },
        /** 打开新增酒店弹窗：不预加载母酒店列表，需选国家+城市后查询 */
        openAddHotelDialog() {
            if (!this.assertCanMaintain()) {
                return;
            }
            this.syncAddHotelTableMaxHeight();
            this.mpage = 1;
            this.mTableData = [];
            this.mTotal = 0;
            this.mother_res_adress = "";
            this.mother_res_phone = "";
            this.mother_search_type = "ai";
            this.centerDialogVisible = true;
        },
        // 获取母酒店列表数据
        showHotelList() {
            if (!this.country_id || !this.city_id) {
                this.$message.warning("请先选择国家和城市后再查询");
                return;
            }
            if (this.mother_search_type === "ai") {
                const addr = this.mother_res_adress
                    ? String(this.mother_res_adress).trim()
                    : "";
                if (!addr) {
                    this.$message.warning("选择 AI 检索时，请填写酒店地址");
                    return;
                }
            }
            Loading.service(options);
            let data = {
                dpID: this.userInfo.id,
                country_id: this.country_id,
                city_id: this.city_id,
                res_name: this.res_name,
                res_adress: this.mother_res_adress,
                res_phone: this.mother_res_phone,
                search_type: this.mother_search_type,
                page: this.mpage,
                start: (this.mpage - 1) * this.mlimit,
                limit: this.mlimit,
                no_t_id: this.no_t_id,
                totalCount: 0,
            };
            this.$axios
                .searchBaseHotel(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    const list = (res && res.dataList) ? res.dataList : [];
                    if (list.length) {
                        this.mTableData = list;
                        this.mTotal = parseInt(res.totalCount, 10) || 0;
                    } else {
                        this.mTableData = [];
                        this.mTotal =
                            res && res.totalCount !== undefined
                                ? parseInt(res.totalCount, 10) || 0
                                : 0;
                    }
                    if (!this.centerDialogVisible) {
                        this.centerDialogVisible = true;
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                });
        },
        // 母酒店列表更改条数重新请求接口数据
        mHandleSizeChange(e) {
            this.mpage = 1;
            this.mlimit = e;
            this.showHotelList();
        },
        // 母酒店列表修改页数
        mHandleCurrentChange(e) {
            this.mpage = e;
            this.showHotelList();
        },
        // 酒店列表更改条数重新请求接口数据
        handleSizeChange(e) {
            this.page = 1;
            this.limit = e;
            this.hotelList();
        },
        // 修改页数
        handleCurrentChange(e) {
            this.page = e;
            this.hotelList();
        },
        // 查看该酒店下房型
        lookRoomType(e) {
            localStorage.setItem('chooseHotel',JSON.stringify(e))
            this.$router.push({ path: "/roomType" });
        },
        // 验证通过即发送编辑请求
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sendEditHotel();
                } else {
                    return false;
                }
            });
        },
        // 删除酒店
        delHotel(e) {
            Loading.service(options);
            let data = {
                id: e.res_id,
            };
            this.$axios
                .deleteHotel(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res) {
                        this.hotelList();
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                    
                });
        },
        openAddHotelConfirm(row) {
            this.addHotelConfirmRow = row;
            this.addHotelConfirmVisible = true;
        },
        submitAddHotelConfirm() {
            var row = this.addHotelConfirmRow;
            this.addHotelConfirmVisible = false;
            this.addHotelConfirmRow = null;
            if (row) {
                this.addHotel(row);
            }
        },
        // 新增酒店（母酒店）：艺龙无 show_res_id 时由服务端先拉取再匹配
        addHotel(e) {
            if (!this.assertCanMaintain()) {
                return;
            }
            Loading.service(options);
            const showId =
                e.show_res_id !== undefined &&
                e.show_res_id !== null &&
                String(e.show_res_id).trim() !== ""
                    ? String(e.show_res_id).trim()
                    : "";
            const outId =
                e.out_res_id !== undefined &&
                e.out_res_id !== null &&
                String(e.out_res_id).trim() !== ""
                    ? String(e.out_res_id).trim()
                    : "";
            let data = {
                show_res_id: showId,
                out_res_id: outId,
                code: e.code != null && e.code !== "" ? String(e.code).trim() : "",
                search_type: this.mother_search_type || "",
                dp_id: this.userInfo.dp_id,
                dp_name: this.userInfo.name,
                pro_up: 1,
            };
            this.$axios
                .editMatchingHotel(qs.stringify(data))
                .then((res) => {
                    Loading.service(options).close();
                    if (res) {
                        this.res_name = "";
                        this.page = 1;
                        this.centerDialogVisible = false;
                        this.hotelList();
                    }
                })
                .catch((err) => {
                    Loading.service(options).close();
                    
                });
        },
        changeStatus() {
            this.page = 1;
            this.hotelList();
        },
        remoteMethod(e){
            setTimeout(()=>{
                this.cityQueryData(e);
            },500)
        },
        hotelCardRowKey(row, idx) {
            if (row && row.res_id !== undefined && row.res_id !== null) {
                return "hotel-" + String(row.res_id);
            }
            return "hotel-row-" + idx;
        },
        hotelMatchStatusTone(row) {
            const s = row && row.status != null ? String(row.status) : "";
            if (s === "已配") return "ok";
            if (s === "未配") return "danger";
            return "info";
        },
        motherHotelCardKey(row, idx) {
            if (!row) return "mh-row-" + idx;
            var keys = ["show_res_id", "out_res_id", "code"];
            for (var i = 0; i < keys.length; i++) {
                var k = keys[i];
                if (
                    row[k] !== undefined &&
                    row[k] !== null &&
                    String(row[k]).trim() !== ""
                ) {
                    return "mh-" + String(row[k]).trim() + "-" + idx;
                }
            }
            if (row.res_name)
                return (
                    "mh-name-" +
                    idx +
                    "-" +
                    String(row.res_name).slice(0, 24)
                );
            return "mh-row-" + idx;
        },
    },
};
</script>

<style scoped>
.hundred {
    width: 130px;
}
.hundred-eight {
    width: 180px;
}
.hundreds {
    width: 500px;
}
.el-date-editor /deep/ .el-range-separator {
    width: 6%;
}

/* —— 移动端：折叠筛选 + 卡片列表 —— */
.hotel-page {
    text-align: left;
}
.hotel-mobile-filters {
    margin-bottom: 12px;
}
.hotel-mobile-filters /deep/ .el-collapse {
    border: none;
}
.hotel-mobile-filters /deep/ .el-collapse-item__header {
    height: 40px;
    line-height: 40px;
    padding-left: 12px;
    font-size: 14px;
    background: #fff;
    border-radius: 8px 8px 0 0;
    border: 1px solid #ebeef5;
    border-bottom: none;
}
.hotel-mobile-filters /deep/ .el-collapse-item__wrap {
    border-bottom: none;
}
.hotel-mobile-filters /deep/ .el-collapse-item__content {
    padding-bottom: 10px;
    padding-top: 4px;
    background: #fff;
    border: 1px solid #ebeef5;
    border-top: none;
    border-radius: 0 0 8px 8px;
}
.hotel-m-fields {
    padding: 0 12px 8px;
}
.hotel-m-field {
    margin-bottom: 12px;
}
.hotel-m-field:last-child {
    margin-bottom: 4px;
}
.hotel-m-label {
    display: block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
}
.hotel-m-control {
    width: 100% !important;
}
.hotel-m-actions {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 8px;
    margin-top: 10px;
    padding: 0 2px;
}
.hotel-m-actions .el-button {
    flex: 1;
    margin-left: 0 !important;
    padding-left: 8px;
    padding-right: 8px;
}
.hotel-card-list {
    margin-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.hotel-card {
    background: #fff;
    border-radius: 8px;
    padding: 10px 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;
    box-sizing: border-box;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
}
.hotel-card:active {
    background: #fafafa;
}
.hotel-card__head {
    margin-bottom: 4px;
}
.hotel-card__title {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    word-break: break-word;
    padding-right: 8px;
    flex: 1;
    min-width: 0;
    line-height: 1.35;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.hotel-card__badge {
    flex-shrink: 0;
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 4px;
    font-weight: 500;
    line-height: 1.4;
}
.hotel-card__badge--ok {
    background: #f0f9eb;
    color: #67c23a;
}
.hotel-card__badge--danger {
    background: #fef0f0;
    color: #f56c6c;
}
.hotel-card__badge--info {
    background: #f4f4f5;
    color: #909399;
}
.hotel-card__row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
    line-height: 1.35;
    margin-bottom: 3px;
}
.hotel-card__row--split {
    margin-bottom: 3px;
}
.hotel-card__k {
    color: #909399;
    flex-shrink: 0;
    margin-right: 4px;
}
.hotel-card__v {
    color: #606266;
    text-align: right;
    word-break: break-word;
    flex: 1;
    min-width: 0;
}
.hotel-card__inline {
    flex: 1;
    min-width: 0;
    color: #303133;
    word-break: break-word;
}
.hotel-card__inline--r {
    flex: 0 1 auto;
    text-align: right;
    white-space: nowrap;
}
.hotel-card__addr {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.hotel-card__remark {
    font-size: 11px;
    color: #606266;
    background: #f5f7fa;
    padding: 4px 6px;
    border-radius: 4px;
    margin-top: 4px;
    line-height: 1.4;
    word-break: break-word;
}
.hotel-card__foot {
    display: flex;
    justify-content: flex-end;
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #f2f3f5;
}
.hotel-card__foot-link {
    color: #409eff;
    font-size: 12px;
    font-weight: 500;
}
.hotel-card-empty {
    text-align: center;
    color: #909399;
    font-size: 14px;
    padding: 36px 16px;
    background: #fff;
    border-radius: 10px;
    border: 1px dashed #dcdfe6;
}

.add-hotel-body {
    margin: -8px 0 0;
}
.add-hotel-tip {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 12px;
    margin-bottom: 16px;
    line-height: 1.55;
    font-size: 12px;
    color: #606266;
    background: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 6px;
}
.add-hotel-tip__icon {
    flex-shrink: 0;
    margin-top: 2px;
    font-size: 14px;
    color: #409eff;
}
.add-hotel-tip__text {
    margin: 0;
    padding: 0;
}
.add-hotel-toolbar {
    padding: 16px 18px;
    margin-bottom: 14px;
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-radius: 8px;
}
.add-hotel-grid {
    display: grid;
    grid-template-columns: 72px minmax(0, 1fr) 72px minmax(0, 1fr);
    column-gap: 16px;
    row-gap: 16px;
    align-items: center;
}
.gh-lbl {
    font-size: 12px;
    color: #606266;
    text-align: left;
    line-height: 32px;
    white-space: nowrap;
}
.gh-field {
    width: 100%;
    min-width: 0;
}
.gh-span-rest {
    grid-column: 2 / -1;
}
.add-hotel-req {
    color: #f56c6c;
    margin-left: 2px;
}
.add-hotel-list-head {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 16px;
    margin-bottom: 10px;
    padding-top: 4px;
}
.add-hotel-table-caption {
    margin-bottom: 0;
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    text-align: left;
    flex: 1;
    min-width: 200px;
}
.add-hotel-query-bar {
    flex-shrink: 0;
}
.add-hotel-list-head--m {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
}
.add-hotel-list-head--m .add-hotel-table-caption {
    min-width: 0;
}
.add-hotel-list-head--m .add-hotel-query-bar {
    width: 100%;
}
.add-hotel-list-head--m .add-hotel-query-btn {
    width: 100%;
}
.add-hotel-m-cards {
    margin-top: 4px;
    max-height: min(380px, 42vh);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.add-hotel-m-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 10px;
    padding: 12px;
    margin-bottom: 10px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
}
.add-hotel-m-card__title {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    line-height: 1.45;
    word-break: break-word;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f2f3f5;
}
.add-hotel-m-card__row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 6px;
}
.add-hotel-m-card__block {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 6px;
    font-size: 13px;
    line-height: 1.5;
}
.add-hotel-m-card__k {
    color: #909399;
    flex-shrink: 0;
}
.add-hotel-m-card__row .add-hotel-m-card__v {
    color: #606266;
    word-break: break-word;
    text-align: right;
}
.add-hotel-m-card__block .add-hotel-m-card__v {
    color: #606266;
    word-break: break-word;
    text-align: left;
}
.add-hotel-m-card__foot {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px solid #f2f3f5;
}
.add-hotel-m-card__bind {
    width: 100%;
    margin-left: 0 !important;
}
.add-hotel-m-card-empty {
    text-align: center;
    color: #909399;
    font-size: 13px;
    padding: 28px 12px;
    border: 1px dashed #dcdfe6;
    border-radius: 8px;
    background: #fafafa;
}
.add-hotel-table-wrap {
    width: 100%;
    border-radius: 4px;
}
.add-hotel-table {
    width: 100%;
}
.add-hotel-pagination {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
}
</style>

<style>
/* el-dialog 挂载在 body 下，需非 scoped 才能作用到 .add-hotel-dialog */
.add-hotel-dialog.el-dialog {
    border-radius: 10px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
}
.add-hotel-dialog .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #ebeef5;
}
.add-hotel-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}
.add-hotel-dialog .el-dialog__body {
    padding: 16px 20px 8px;
    color: #606266;
}
.add-hotel-dialog .el-dialog__footer {
    padding: 10px 20px 16px;
    border-top: 1px solid #ebeef5;
}
.add-hotel-footer {
    display: flex;
    justify-content: flex-end;
}

/* 新增酒店弹窗 — 窄屏（custom-class 挂在 .el-dialog 根上） */
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile {
    margin-top: 3vh !important;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .el-dialog__header {
    padding: 12px 44px 10px 14px;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .el-dialog__headerbtn {
    top: 6px;
    right: 4px;
    padding: 10px;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .el-dialog__body {
    padding: 12px 14px 10px;
    max-height: 72vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .el-dialog__footer {
    padding: 10px 14px calc(12px + env(safe-area-inset-bottom, 0px));
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .add-hotel-grid {
    grid-template-columns: 64px minmax(0, 1fr);
    column-gap: 10px;
    row-gap: 12px;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .add-hotel-tip {
    font-size: 11px;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .add-hotel-pagination {
    justify-content: center;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .add-hotel-footer--m {
    flex-direction: column-reverse;
    width: 100%;
}
.el-dialog.add-hotel-dialog.add-hotel-dialog--mobile .add-hotel-footer--m .el-button {
    width: 100%;
    margin: 0 !important;
    min-height: 44px;
    font-size: 15px;
}

/* 新增酒店 — 确认绑定（移动端 dialog，挂载在 body） */
.add-hotel-confirm-dialog.el-dialog {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.16);
}
.add-hotel-confirm-dialog .el-dialog__header {
    padding: 18px 20px 10px;
    border-bottom: 1px solid #eef0f4;
}
.add-hotel-confirm-dialog .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: #303133;
    line-height: 1.35;
}
.add-hotel-confirm-dialog .el-dialog__headerbtn {
    top: 12px;
    right: 12px;
    font-size: 18px;
}
.add-hotel-confirm-dialog .el-dialog__body {
    padding: 18px 20px 8px;
}
.add-hotel-confirm-dialog .add-hotel-confirm-body {
    display: flex;
    align-items: flex-start;
    gap: 14px;
}
.add-hotel-confirm-dialog .add-hotel-confirm-ico {
    flex-shrink: 0;
    font-size: 36px;
    color: #e6a23c;
    line-height: 1;
    margin-top: 2px;
}
.add-hotel-confirm-dialog .add-hotel-confirm-title {
    margin: 0 0 10px;
    font-size: 16px;
    line-height: 1.55;
    color: #303133;
    font-weight: 500;
}
.add-hotel-confirm-dialog .add-hotel-confirm-sub {
    margin: 0;
    padding: 10px 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #606266;
    word-break: break-word;
    background: #f5f7fa;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}
.add-hotel-confirm-dialog .el-dialog__footer {
    padding: 10px 20px 18px;
    border-top: 1px solid #eef0f4;
}
.add-hotel-confirm-dialog .add-hotel-confirm-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    flex-wrap: wrap;
}
.add-hotel-confirm-dialog .add-hotel-confirm-footer .el-button {
    min-width: 96px;
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile {
    margin-top: 12vh !important;
    max-width: min(400px, calc(100vw - 24px));
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .el-dialog__header {
    padding: 16px 40px 8px 16px;
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .el-dialog__body {
    padding: 12px 16px 6px;
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .add-hotel-confirm-ico {
    font-size: 32px;
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .el-dialog__footer {
    padding: 12px 16px;
    padding-bottom: max(16px, env(safe-area-inset-bottom, 0px));
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .add-hotel-confirm-footer {
    flex-direction: column;
    width: 100%;
    gap: 10px;
}
.el-dialog.add-hotel-confirm-dialog.add-hotel-confirm-dialog--mobile
    .add-hotel-confirm-footer
    .el-button {
    width: 100%;
    margin: 0 !important;
    min-height: 46px;
    font-size: 15px;
    border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel.vue